import { defineMessages } from 'react-intl';
import type { IntlShape } from 'react-intl';

import {
  ACEITE_AVISO_PADRAO,
  ACEITE_BOTAO_PADRAO,
  ACEITE_TEXTO_PADRAO,
} from './helpers';

const messages = defineMessages({
  titleBlock: {
    id: 'mpf_aceite_termos_block',
    defaultMessage: 'Aceite de termos',
  },
  textoCheckbox: {
    id: 'mpf_aceite_termos_texto_checkbox',
    defaultMessage: 'Texto da caixa de aceite',
  },
  botaoRotulo: {
    id: 'mpf_aceite_termos_botao_rotulo',
    defaultMessage: 'Rótulo do botão',
  },
  href: { id: 'mpf_aceite_termos_href', defaultMessage: 'Destino do botão' },
  hrefHelp: {
    id: 'mpf_aceite_termos_href_help',
    defaultMessage:
      'Página do site ou endereço externo. Sem destino, o bloco não aparece no site.',
  },
  novaAba: {
    id: 'mpf_aceite_termos_nova_aba',
    defaultMessage: 'Abrir em nova aba',
  },
  mensagemAviso: {
    id: 'mpf_aceite_termos_mensagem_aviso',
    defaultMessage: 'Aviso quando os termos não foram aceitos',
  },
  padraoHelp: {
    id: 'mpf_aceite_termos_padrao_help',
    defaultMessage: 'Em branco, usa "{padrao}".',
  },
});

export const mpfAceiteTermosSchema = ({ intl }: { intl: IntlShape }) => ({
  title: intl.formatMessage(messages.titleBlock),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
        'textoCheckbox',
        'botaoRotulo',
        'href',
        'novaAba',
        'mensagemAviso',
      ],
    },
  ],
  properties: {
    textoCheckbox: {
      title: intl.formatMessage(messages.textoCheckbox),
      description: intl.formatMessage(messages.padraoHelp, {
        padrao: ACEITE_TEXTO_PADRAO,
      }),
      placeholder: ACEITE_TEXTO_PADRAO,
    },
    botaoRotulo: {
      title: intl.formatMessage(messages.botaoRotulo),
      description: intl.formatMessage(messages.padraoHelp, {
        padrao: ACEITE_BOTAO_PADRAO,
      }),
      placeholder: ACEITE_BOTAO_PADRAO,
    },
    href: {
      title: intl.formatMessage(messages.href),
      description: intl.formatMessage(messages.hrefHelp),
      widget: 'object_browser',
      mode: 'link',
      selectedItemAttrs: ['@id', '@type', 'Title'],
      allowExternals: true,
      initialPath: '/',
    },
    novaAba: {
      title: intl.formatMessage(messages.novaAba),
      type: 'boolean',
    },
    mensagemAviso: {
      title: intl.formatMessage(messages.mensagemAviso),
      description: intl.formatMessage(messages.padraoHelp, {
        padrao: ACEITE_AVISO_PADRAO,
      }),
      placeholder: ACEITE_AVISO_PADRAO,
    },
  },
  required: ['href'],
});

export default mpfAceiteTermosSchema;
